import React from "react";
import PropTypes from "prop-types";
import { map, get, size } from "lodash";

import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";

import HeaderCell from "./HeaderCell";
import LazyLoadContainer from "../LazyLoadContainer";

const ScrollableTable = (props) => {
  const {
    columns,
    lazyLoading = false,
    fetchData,
    hasMore,
    isFetching = false,
    containerHeight,
    allowPII=true
  } = props;

  if (allowPII){
    try {
      delete columns[5].filter
    } catch {
      
    }
    
  }

  if (lazyLoading) {
    return (
      <LazyLoadContainer
        loadMore={fetchData}
        hasMore={hasMore}
        containerHeight={containerHeight}
      >
        <Table stickyHeader={props.stickyHeader}>
          <TableHead>
            <TableRow>
              {map(columns, (col, index) => (
                <HeaderCell
                  key={index}
                  column={col}
                  lov={get(props.lov, [get(col, ["filter", "name"])])}
                  filterValue={get(props.filters, [
                    get(col, ["filter", "name"]),
                  ])}
                  handleFilterChange={(e) =>
                    props.handleFilterChange(
                      get(e, ["target", "value"]) !== undefined
                        ? get(e, ["target", "value"])
                        : e,
                      get(col, ["filter", "name"])
                    )
                  }
                  data={props.data}
                />
              ))}
            </TableRow>
          </TableHead>
          <TableBody>{props.children}</TableBody>
        </Table>
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "40px",
          }}
        >
          {isFetching && <CircularProgress size={20} />}
        </Box>
      </LazyLoadContainer>
    );
  }

  return (
    <>
      <Table stickyHeader={props.stickyHeader}>
        <TableHead>
          <TableRow>
            {map(columns, (col, index) => (
              <HeaderCell
                key={index}
                column={col}
                lov={get(props.lov, [get(col, ["filter", "name"])])}
                filterValue={get(props.filters, [get(col, ["filter", "name"])])}
                handleFilterChange={(e) =>
                  props.handleFilterChange(
                    get(e, ["target", "value"]) || e,
                    get(col, ["filter", "name"])
                  )
                }
                handleFilterClose={(e) => {
                  if (props.handleFilterClose) {
                    props.handleFilterClose(props.filters);
                  }
                }}
                data={props.data}
                isLast={index === size(columns) - 1}
              />
            ))}
          </TableRow>
        </TableHead>
        <TableBody>{props.children}</TableBody>
      </Table>
      {!props.hideLoadingBar && (
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "40px",
          }}
        >
          {isFetching && <CircularProgress size={20} />}
        </Box>
      )}
    </>
  );
};

ScrollableTable.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.number,
      minWidth: PropTypes.number,
    })
  ),
  fetchData: PropTypes.func,
  hasMore: PropTypes.bool,
};

export default ScrollableTable;
